import React, { useCallback, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { usePermissions } from "../../Context/permissionContext";
import { useAuth } from "../../hooks/AuthProvider";
import { getIconFromName } from "../../utils/getIconFromName";
import { isTypeUser } from "../../utils/isTypeUser";

function SubMenuItem({
  title,
  typePermission,
  iconName,
  route,
  paymentsClick,
  onSubMenuClick,
  salesClick,
  onlyForRpeUsers,
  onlyForRpeRoleUsers,
  dataTestId,
}) {
  const { permissions } = usePermissions();
  const navigate = useNavigate();
  const { user } = useAuth();

  const isRpeTypeUser = isTypeUser("RPE", user?.type_user);
  const isRpeRoleUser = isTypeUser("RPE", user?.type_role_user);

  const shouldShowByTypeUser = onlyForRpeUsers ? isRpeTypeUser : true;
  const shouldShowByRoleUser = onlyForRpeRoleUsers ? isRpeRoleUser : true;


  const [shouldRenderComponent, setShouldRenderComponent] = useState(false);

  const icon = getIconFromName(iconName);

  const routeActions = {
    "modal-paymentsClick": paymentsClick,
    "modal-salesClick": salesClick,
  };


  const changeRouteClick = useCallback(
    (route) => {
      const action = routeActions[route];
      if (action) {
        action();
      } else {
        navigate(route);
      }
      onSubMenuClick?.(false);
    },
    [navigate, onSubMenuClick]
  );

  useEffect(() => {
    if (!typePermission) {
      setShouldRenderComponent(true);
      return;
    }

    const typePermissionValue = typePermission.map((item) => item.id);

    setShouldRenderComponent(
      typePermissionValue.some((permission) =>
        permissions.includes(permission)
      )
    );
  }, [permissions, typePermission]);

  return (
    <>
      {permissions && shouldRenderComponent && shouldShowByTypeUser && shouldShowByRoleUser && (
        <li
          onClick={() => changeRouteClick(route)}
          data-testid={dataTestId}
        >
          <div className="newmenu-item__icon-sub">{icon}</div>
          <p>{title}</p>
        </li>
      )}
    </>
  );
}
export default SubMenuItem;
